import { useCallback, useEffect, useRef, useState } from 'react';
import { collectDeviceLocation } from './deviceLocation';

const empty = { busy: false, progress: 0, error: '', errorCode: '', message: '', lastFix: null };
export const useGPSCapture = () => {
  const [state, setState] = useState(empty);
  const controller = useRef(null);
  const generation = useRef(0);
  const cancel = useCallback(() => {
    generation.current++; controller.current?.abort(); controller.current = null;
    setState(s => ({ ...s, busy: false, error: '', message: 'Location capture cancelled.' }));
  }, []);
  const reset = useCallback(() => { cancel(); setState(empty); }, [cancel]);
  useEffect(() => () => { generation.current++; controller.current?.abort(); }, []);
  const collect = useCallback(async (setting = false) => {
    const run = ++generation.current;
    controller.current?.abort();
    const current = new AbortController(); controller.current = current;
    setState({ ...empty, busy: true, message: 'Requesting phone location…' });
    try {
      const readings = await collectDeviceLocation({ signal: current.signal, accuracyLimit: setting ? 5 : 15,
        onUpdate: ({ fix, ...update }) => {
          if (generation.current === run) setState(s => ({ ...s, ...update, lastFix: fix || s.lastFix }));
        },
      });
      if (generation.current === run) setState(s => ({ ...s, busy: false }));
      return readings;
    } catch (error) {
      if (generation.current === run) setState(s => ({ ...s, busy: false, error: error.name === 'AbortError' ? '' : error.message, errorCode: error.code || '' }));
      throw error;
    } finally { if (generation.current === run) controller.current = null; }
  }, []);
  return { ...state, collect, cancel, reset };
};